/**
 * @file Sizes for Avatar component.
 */

export const AVATAR_SIZE_18 = 18;
export const AVATAR_SIZE_28 = 28;
export const AVATAR_SIZE_36 = 36;
export const AVATAR_SIZE_42 = 42;
export const AVATAR_SIZE_52 = 52;
export const AVATAR_SIZE_72 = 72;
export const AVATAR_SIZE_96 = 96;
